"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormulaValueEditor = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _emotion = require("emotion");

var _mathEvaluationHelper = _interopRequireDefault(require("@cimpress-technology/math-evaluation-helper"));

var _formulaEditor = _interopRequireWildcard(require("@cimpress-technology/formula-editor"));

require("@cimpress-technology/formula-editor/lib/styles.css");

var _FormulaInfoModal = require("./FormulaInfoModal");

var _propTypes2 = require("../../shared/propTypes");

var _operators = require("../../shared/enums/operators");

var _formulaDefinition = _interopRequireWildcard(require("./formulaDefinition"));

var _messages = _interopRequireDefault(require("./messages"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n   {\n    position: absolute;\n    bottom: 10px;\n    right: 10px;\n    z-index: 50;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   {\n    position: relative;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

_formulaEditor["default"].registerLanguage(_formulaDefinition["default"]);

var positionRelative = (0, _emotion.css)(_templateObject());
var positionInfoModal = (0, _emotion.css)(_templateObject2());

var validateValue = function validateValue(value) {
  if (!value) {
    throw new Error('FormulaValueEditor did not receive a valid value');
  } else if (value.type && value.type !== _operators.FORMULA) {
    throw new Error('FormulaValueEditor received a non-formula value');
  }
};

var computeEditorState = function computeEditorState(value) {
  return value && value.formula ? _formulaEditor.EditorState.createFromText(value.formula) : _formulaEditor.EditorState.createEmpty();
};

var FormulaValueEditor = function FormulaValueEditor(_ref) {
  var value = _ref.value,
      variableNames = _ref.variableNames,
      onValueChanged = _ref.onValueChanged;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var _useState = (0, _react.useState)(function () {
    return computeEditorState(value);
  }),
      _useState2 = _slicedToArray(_useState, 2),
      editorState = _useState2[0],
      updateEditorState = _useState2[1];

  var _useState3 = (0, _react.useState)(_formulaEditor.Completions.create(_toConsumableArray(_formulaDefinition.functionCompletions))),
      _useState4 = _slicedToArray(_useState3, 2),
      completions = _useState4[0],
      updateCompletions = _useState4[1];

  var _useState5 = (0, _react.useState)({}),
      _useState6 = _slicedToArray(_useState5, 2),
      validationContext = _useState6[0],
      updateValidationContext = _useState6[1];

  var _useState7 = (0, _react.useState)({}),
      _useState8 = _slicedToArray(_useState7, 2),
      validationState = _useState8[0],
      updateValidationState = _useState8[1];

  var variableNamesJSON = JSON.stringify(variableNames);
  var memoizedVariableNames = (0, _react.useMemo)(function () {
    return JSON.parse(variableNamesJSON);
  }, [variableNamesJSON]); // now memoizedVariableNames is only a new array instance if its contents have actually changed, so we can use it as a dependency for useEffects

  (0, _react.useEffect)(function () {
    validateValue(value);
  }, [value]);
  var computeValidationState = (0, _react.useMemo)(function () {
    return function (editorState) {
      var formula = _formulaEditor.EditorState.getText(editorState);

      try {
        _mathEvaluationHelper["default"].validate(formula, validationContext);

        updateValidationState({
          formula: formula
        });
      } catch (err) {
        updateValidationState({
          formula: formula,
          validationError: err.message
        });
      }
    };
  }, [validationContext]);
  (0, _react.useEffect)(function () {
    var variableCompletions = memoizedVariableNames.map(function (variableName) {
      return ["#{".concat(variableName, "}")];
    });

    var newCompletions = _formulaEditor.Completions.create([].concat(_toConsumableArray(_formulaDefinition.functionCompletions), _toConsumableArray(variableCompletions)));

    updateCompletions(newCompletions);
    var validVariables = memoizedVariableNames.reduce(function (accumulator, variableName) {
      return _objectSpread(_objectSpread({}, accumulator), {}, _defineProperty({}, variableName, 1));
    }, {});
    updateValidationContext(validVariables);
  }, [memoizedVariableNames]); // eslint-disable-line react-hooks/exhaustive-deps

  (0, _react.useEffect)(function () {
    computeValidationState(editorState);
  }, [editorState, computeValidationState]);
  (0, _react.useEffect)(function () {
    if (validationState.formula && validationState.formula !== value.formula) {
      onValueChanged({
        type: _operators.FORMULA,
        formula: validationState.formula
      });
    }
  }, [validationState, onValueChanged]);

  if (value) {
    return (
      /*#__PURE__*/
      _react["default"].createElement("div", {
        className: positionRelative
      },
      /*#__PURE__*/
      _react["default"].createElement(_FormulaInfoModal.FormulaInfoModal, {
        className: positionInfoModal
      }),
      /*#__PURE__*/
      _react["default"].createElement(_formulaEditor["default"], {
        label: formatMessage(_messages["default"].enterFormula),
        editorState: editorState,
        completions: completions,
        language: 'rules',
        onChange: updateEditorState,
        "data-testid": "FormulaInput"
      }), validationState.validationError ?
      /*#__PURE__*/
      _react["default"].createElement("span", {
        className: "text-danger",
        "data-testid": "FormulaError"
      }, validationState.validationError) : null)
    );
  }

  return null;
};

exports.FormulaValueEditor = FormulaValueEditor;
FormulaValueEditor.propTypes = {
  value: _propTypes["default"].shape(_propTypes2.valueShape),
  variableNames: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  onValueChanged: _propTypes["default"].func.isRequired
};
FormulaValueEditor.defaultProps = {
  value: {
    type: _operators.FORMULA
  }
};